import script from "./DescriptionFieldTemplatesSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionFieldTemplatesSelect.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionFieldTemplatesSelect.vue?vue&type=style&index=0&id=8ff5411a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ff5411a"]])

export default __exports__